import {
  DatabaseIcon,
  InfoIcon,
  KeyIcon,
  LockKeyIcon,
  PuzzlePieceIcon,
  StorefrontIcon,
  ToggleRightIcon,
  TranslateIcon,
} from '@phosphor-icons/react'
import { TFunction } from 'i18next'

import { SideNavGroup, SideNavItem } from '@/components/layout/side-nav'

import { PlaceTab } from './place-details.types'
import { isPlaceTabDisabled, isPlaceTabHidden } from './place-details.utils'

// Note: Collapse clips by default, which would stop the sticky group headers from sticking
export const COLLAPSE_STYLE = { flexShrink: 0, overflow: 'visible' } as const

export const PLACE_FEATURES_VIEW_KEY = 'places-features-view'

export const PLACE_FEATURES_OPEN_GROUPS_KEY = 'places-features-open-groups'

export const getPlaceNavGroups = (t: TFunction<['organisation']>): SideNavGroup[] => [
  {
    key: 'integrations',
    label: t('organisation:places.details.nav.groups.integrations'),
  },
]

export const getPlaceNavItems = (
  t: TFunction<['organisation']>,
  { isAdmin, perksAvailable }: { isAdmin: boolean; perksAvailable: boolean },
): SideNavItem<PlaceTab>[] =>
  [
    {
      icon: InfoIcon,
      label: t('organisation:places.details.nav.general'),
      slug: PlaceTab.general,
    },
    {
      icon: ToggleRightIcon,
      label: t('organisation:places.details.nav.features'),
      slug: PlaceTab.features,
    },
    {
      icon: TranslateIcon,
      label: t('organisation:places.details.nav.languages'),
      slug: PlaceTab.languages,
    },
    {
      disabled: isPlaceTabDisabled(PlaceTab.perks, perksAvailable),
      disabledReason: t('organisation:places.perks.perksOff'),
      icon: StorefrontIcon,
      label: t('organisation:places.details.nav.perks'),
      slug: PlaceTab.perks,
    },
    {
      group: 'integrations',
      icon: DatabaseIcon,
      label: t('organisation:places.details.nav.pms'),
      slug: PlaceTab.pms,
    },
    {
      group: 'integrations',
      icon: KeyIcon,
      label: t('organisation:places.details.nav.accessControl'),
      slug: PlaceTab.accessControl,
    },
    {
      group: 'integrations',
      icon: LockKeyIcon,
      label: t('organisation:places.details.nav.credentials'),
      slug: PlaceTab.credentials,
    },
    {
      group: 'integrations',
      icon: PuzzlePieceIcon,
      label: t('organisation:places.details.nav.other'),
      slug: PlaceTab.other,
    },
  ].filter(({ slug }) => !isPlaceTabHidden(slug, isAdmin))
